import React from 'react';

export const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#0B84EE" />
    <path d="M17.3256 16.2903H20.3034L20.7709 13.2469H17.325V11.5835C17.325 10.3192 17.7356 9.19813 18.9111 9.19813H20.8V6.54223C20.4681 6.49714 19.7662 6.39844 18.4399 6.39844C15.6705 6.39844 14.0469 7.86988 14.0469 11.2222V13.2469H11.2V16.2903H14.0469V24.6553C14.6107 24.7406 15.1818 24.7984 15.768 24.7984C16.2979 24.7984 16.8151 24.7497 17.3256 24.6802V16.2903Z" fill="white" />
  </svg>
);

export const InstagramIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Background Circle */}
    <circle cx="16" cy="16" r="16" fill="url(#igGradient)" />

    {/* Camera Outline */}
    <rect
      x="9"
      y="9"
      width="14"
      height="14"
      rx="4"
      stroke="white"
      strokeWidth="2"
    />

    {/* Inner Lens */}
    <circle
      cx="16"
      cy="16"
      r="3.5"
      stroke="white"
      strokeWidth="2"
    />

    {/* Small Dot */}
    <circle cx="20.5" cy="11.5" r="1.2" fill="white" />

    <defs>
      <linearGradient
        id="igGradient"
        x1="0"
        y1="32"
        x2="32"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#F58529" />
        <stop offset="30%" stopColor="#DD2A7B" />
        <stop offset="60%" stopColor="#8134AF" />
        <stop offset="100%" stopColor="#515BD4" />
      </linearGradient>
    </defs>
  </svg>
);


export const TikTokIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_30598_169619)">
      <rect width="32" height="32" rx="16" fill="#111111" />
      <path d="M23.9747 12.2223C23.4228 12.2223 22.8763 12.1136 22.3663 11.9024C21.8564 11.6912 21.3931 11.3817 21.0028 10.9914C20.6126 10.6011 20.303 10.1378 20.0918 9.62789C19.8806 9.11798 19.7718 8.57146 19.7718 8.01953H16.7692V19.7775C16.7686 20.3135 16.5993 20.8358 16.2853 21.2703C15.9714 21.7048 15.5286 22.0294 15.0198 22.1982C14.511 22.367 13.962 22.3714 13.4505 22.2107C12.9391 22.0501 12.4912 21.7325 12.1704 21.3031C11.8495 20.8736 11.6719 20.3541 11.6628 19.8181C11.6537 19.2821 11.8135 18.7569 12.1196 18.3168C12.4257 17.8767 12.8625 17.5441 13.3682 17.3661C13.8739 17.1882 14.4227 17.1739 14.937 17.3253V14.4065C13.8441 14.2591 12.7323 14.4487 11.75 14.9498C10.7677 15.451 9.96167 16.2399 9.43953 17.2112C8.9174 18.1825 8.70402 19.29 8.82787 20.3858C8.95173 21.4816 9.40694 22.5135 10.1327 23.3437C10.8585 24.174 11.8203 24.7631 12.8896 25.0323C13.959 25.3016 15.0851 25.2381 16.1175 24.8506C17.1499 24.463 18.0395 23.7697 18.6674 22.8632C19.2954 21.9567 19.6319 20.8802 19.632 19.7775L19.7191 13.8341C20.9528 14.7398 22.4439 15.2272 23.9744 15.2249L23.9747 12.2223Z" fill="#FFFFFF" />
    </g>
  </svg>
);

export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0Z" fill="black" />
    <path d="M17.7504 14.5517L24.5998 6.58984H22.9767L17.0293 13.503L12.2792 6.58984H6.80054L13.9836 17.0438L6.80054 25.3931H8.42372L14.7043 18.0925L19.7207 25.3931H25.1994L17.75 14.5517H17.7504ZM9.00856 7.81176H11.5017L22.9774 24.2267H20.4843L9.00856 7.81176Z" fill="white" />
  </svg>
);

export const YouTubeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#F40000" />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.00994 21.6455C8.69613 21.5526 8.4098 21.3874 8.17512 21.1639C7.94043 20.9403 7.76427 20.665 7.66151 20.361C7.07429 18.7899 6.9003 12.2295 8.03124 10.9345C8.40764 10.5132 8.93907 10.2538 9.51017 10.2126C12.5441 9.89414 21.9179 9.93661 22.9945 10.3188C23.2973 10.4147 23.5739 10.5762 23.8037 10.7913C24.0335 11.0064 24.2104 11.2695 24.3212 11.5608C24.9628 13.1849 24.9845 19.0871 24.2342 20.6476C24.0352 21.0538 23.7019 21.3828 23.2881 21.5818C22.1572 22.1338 10.5106 22.1231 9.00994 21.6455ZM13.8273 18.567L19.2646 15.807L13.8273 13.0257V18.567Z" fill="white" />
  </svg>
);

export const LinkedInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#2878B7" />
    <path d="M22.4 16.5971V21.0096H19.8171V16.8661C19.8171 15.8437 19.4404 15.1442 18.5256 15.1442C17.826 15.1442 17.3955 15.6285 17.2341 16.059C17.1803 16.2204 17.1265 16.4356 17.1265 16.7047V21.0096H14.5435C14.5435 21.0096 14.5973 14.0141 14.5435 13.3146H17.1265V14.3908C17.4494 13.8527 18.0951 13.0993 19.4404 13.0993C21.1085 13.0993 22.4 14.2294 22.4 16.5971ZM11.8529 9.60156C10.992 9.60156 10.4 10.1935 10.4 10.9469C10.4 11.7002 10.9381 12.2921 11.7991 12.2921C12.7139 12.2921 13.252 11.7002 13.252 10.9469C13.3059 10.1397 12.7677 9.60156 11.8529 9.60156ZM10.5615 21.0096H13.1444V13.3146H10.5615V21.0096Z" fill="white" />
  </svg>
);
